var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"restrictDeposit"}},[_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"inner_max"},[_c('div',{staticClass:"content_title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('restrictDeposit.header')))]),_c('p')]),_c('Result',{attrs:{"info":true}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('restrictDeposit.info'))}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }